import { Component, OnInit, Input } from '@angular/core';
import { ProductDetailComponent } from './product.detail';
import { Product } from '../Models/product';


@Component({
  selector: 'product-preview',
  templateUrl: '../Templates/product.detail.html',
  styleUrls: ['../Styles/product.detail.scss'],
})


export class ProductPreviewComponent extends ProductDetailComponent implements OnInit {

  @Input()
  public product: Product;

  ngOnInit() {

    this.thumbs = [this.product.frontimage,
                   this.product.detailimage,
                   this.product.backimage];

    for (var i = 0; i < this.product.images.length; i++) {
      this.thumbs.push(this.product.images[i].image);
    }

    this.product.reference = "#--------";
  }

  canFollow(obj): boolean {
    return false;
  }

  canUnFollow(obj): boolean {
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/Components/product.preview.ts